import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import logo from './logo.png';
import GitHubWorkflowStatus from "./GitHubWorkflowStatus";

function NavMenu({ username, onLogout }) {
    return (
        <Navbar bg="light" expand="lg">
            <Container fluid>
                <Navbar.Brand href="/" className="me-auto">
                    <img
                        src={logo}
                        height="30"
                        className="d-inline-block align-top"
                        alt="Logo"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/app-services">services</Nav.Link>
                        <Nav.Link href="/sso-services">sso</Nav.Link>
                        {/*<Nav.Link href="/ui">UI</Nav.Link>*/}
                        <Nav.Link href="/changelog">changelog</Nav.Link>
                        {/*<Nav.Link href="/github">GitHub</Nav.Link>*/}
                    </Nav>
                    <GitHubWorkflowStatus/>
                    <Nav>
                        {username && (
                            <>
                                <Navbar.Text className="me-3">
                                    {username}
                                </Navbar.Text>
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    className="py-0 px-2"
                                    style={{ fontSize: '0.8rem', backgroundColor: '#e0e0e0', borderColor: '#e0e0e0', color: '#666' }}
                                    onClick={onLogout}
                                >
                                    Logout
                                </Button>
                            </>
                        )}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavMenu;